import { And, Count, Relation, Not, Or, UnionAll } from '@cotera/era';

export const compareRelations = (lhs: Relation, rhs: Relation) => {
  const lhs_rowcount = lhs
    .groupBy((t) => t.star())
    .select((t) => ({
      ...t.group(),
      __COTERA_ROW_COUNT: Count(),
    }));

  const rhs_rowcount = rhs
    .groupBy((t) => t.star())
    .select((t) => ({
      ...t.group(),
      __COTERA_ROW_COUNT: Count(),
    }));

  const leftjoin = lhs_rowcount.leftJoin(rhs_rowcount, (l, r) => ({
    on: And(
      ...Object.entries(l.star()).map(([name, expr]) =>
        Not(expr.isDistinctFrom(r.attr(name)))
      )
    ),
    select: {
      ...l.renameWith((name) => `left_${name}`),
      ...r.renameWith((name) => `right_${name}`),
    },
  }));

  const rightjoin = lhs_rowcount.rightJoin(rhs_rowcount, (l, r) => ({
    on: And(
      ...Object.entries(r.star()).map(([name, expr]) =>
        Not(expr.isDistinctFrom(l.attr(name)))
      )
    ),
    select: {
      ...l.renameWith((name) => `left_${name}`),
      ...r.renameWith((name) => `right_${name}`),
    },
  }));

  return UnionAll([leftjoin, rightjoin]).where((t) =>
    Or(
      ...Object.keys(lhs.attributes).map((name) =>
        t.attr(`left_${name}`).isDistinctFrom(t.attr(`right_${name}`))
      )
    )
  );
};
